import { render } from "./MatchByValue.vue?vue&type=template&id=5bd5e2d0"
import script from "./MatchByValue.vue?vue&type=script&lang=js"
export * from "./MatchByValue.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__